import { combineReducers } from 'redux';

import initRequestStatus from './initRequestStatus';
import loadingScreenStatus from './loadingScreenStatus';
import reportsLoadingStatuses from './reportsLoadingStatuses';
import enrollmentLoadingStatus from './enrollmentLoadingStatus';

const loadingStatus = combineReducers({
  loadingScreenStatus,
  initRequestStatus,
  reportsLoadingStatuses,
  enrollmentLoadingStatus,
});

export default loadingStatus;
